import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 获取字典
export const GET_ALL_DICT_DETAILS = () =>
  GET(`${HTTP}/boot/dict/getAllDictDetails`)
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

// 获取字典
export const GET_ALL_DICT_DETAILS = () =>
  GET(`${HTTP}/boot/dict/getAllDictDetails`)
